const page = document.querySelector('.page');
const pinnedClass = '--header-pinned';

// add logic for header height update

const checkHeader = (e) => {
	const pos = window.scrollY;

	if(pos < 108){
		page.classList.remove(pinnedClass);
		return 
	}

	page.classList.add(pinnedClass);
};

checkHeader();
window.addEventListener("scroll", checkHeader);